import type { SuggestedProductCollection, BrandFilter } from 'src/types';

export function extractFilter(suggestion: SuggestedProductCollection) {
  if (suggestion.topBrands?.length) {
    return { ...suggestion };
  }

  const brandFilter = suggestion.filters.find(
    filter => filter?.__typename === 'BrandFilter'
  ) as BrandFilter;

  const brandFilterData = brandFilter
    ? {
        text: `${brandFilter.name} ${suggestion.text}`,
        path: `${suggestion.path}${brandFilter.param}`,
      }
    : {};

  return { ...brandFilterData };
}
